(() => {
  const active = [];

  const container = document.getElementById('content-filter');
  const open = document.getElementById('content-filter-open');
  const close = document.getElementById('content-filter-close');
  const clear = document.getElementById('content-filter-clear');
  const filters = container.querySelectorAll('.filter-option');

  open.addEventListener('click', () => {
    container.classList.add('open');
  });

  close.addEventListener('click', () => {
    container.classList.remove('open');
  });

  clear.addEventListener('click', () => {
    active.length = 0;
    filters.forEach((f) => { f.classList.remove('selected'); });
    getContent(active);
  });
  
  filters.forEach((f) => {
    f.addEventListener(('click'), () => {
      const name = f.getAttribute('data-name');
      const index = active.indexOf(name);
      if (index >= 0) {
        active.splice(index,1);
        f.classList.remove('selected');
      } else {
        active.push(name);
        f.classList.add('selected');
      }
      getContent(active);
    });
  });

  function setAwaiting(value) {
    if (value) {
      container.classList.add('awaiting');
    } else {
      container.classList.remove('awaiting');
    }
  }

  function swapContent(resp) {
    const dest = document.getElementById('section-api-target');
    const parser = new DOMParser();
    const tempDoc = parser.parseFromString(resp, "text/html");
    const src = tempDoc.getElementById('section-api-target');
    dest.innerHTML = src.innerHTML;

    var postsToAnimate = dest.querySelectorAll('.item-animate');
    if(postsToAnimate && ww > 749){
      postsToAnimate.forEach(function(element){
        stickyObserver.observe(element);
      });
    }
  }

  const getContent = debounce((tags) => {
    setAwaiting(true);
    
    const url = '/blogs/education/' + (tags.length ? `/tagged/${tags.join('+')}` : '') + '?section_id=main-blog';
    
    fetch(url)
      .then((resp) => resp.text())
      .then((resp) => {
        swapContent(resp);
      })
      .catch((err) => {
        console.log(err);
        // @todo: show some kind of error message to the user
      })
      .finally(() => {
        setAwaiting(false);
      });
  }, 1000);
})();